


export class ObraMySuporte {
  "lote";
  "description";
  "vendorName";
  "numeroDaPO";
  "itemDePO";
  "grQty";
  "unitPrice";
  "grTotalAmount";
  "integradoMySuporte";
  "numeroChamadoMySuporte";
  "id";
  constructor(data) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `ObraMySuporte`.
   */
  static getModelName() {
    return "ObraMySuporte";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of ObraMySuporte for dynamic purposes.
  **/
  static factory(data) {
    return new ObraMySuporte(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  static getModelDefinition() {
    return {
      name: 'ObraMySuporte',
      plural: 'ObraMySuportes',
      path: 'ObraMySuportes',
      properties: {
        "lote": {
          name: 'lote',
          type: 'number'
        },
        "description": {
          name: 'description',
          type: 'string'
        },
        "vendorName": {
          name: 'vendorName',
          type: 'string'
        },
        "numeroDaPO": {
          name: 'numeroDaPO',
          type: 'string'
        },
        "itemDePO": {
          name: 'itemDePO',
          type: 'number'
        },
        "grQty": {
          name: 'grQty',
          type: 'number'
        },
        "unitPrice": {
          name: 'unitPrice',
          type: 'number'
        },
        "grTotalAmount": {
          name: 'grTotalAmount',
          type: 'number'
        },
        "integradoMySuporte": {
          name: 'integradoMySuporte',
          type: 'boolean'
        },
        "numeroChamadoMySuporte": {
          name: 'numeroChamadoMySuporte',
          type: 'boolean'
        },
        "id": {
          name: 'id',
          type: 'number'
        },
      },
      relations: {
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/sdk/models/ObraMySuporte.js